import { z } from 'zod';
import { cognitoPasswordSchema } from './cognitoPassword';

export const menteeSignUpFormSchema = z
  .object({
    mentorshipFocus: z
      .array(z.string())
      .nonempty('At least one focus is required'),
    firstName: z.string().min(1, 'First name is required'),
    lastName: z.string().min(1, 'Last name is required'),
    email: z.string().email('Invalid email'),
    password: cognitoPasswordSchema,
    confirmPassword: z
      .string()
      .min(8, 'Confirm password must be at least 8 characters long'),
    city: z.string().min(2, { message: 'City is required' }),
    stateProvince: z.string().min(2, { message: 'This field is required' }),
    country: z.string().min(3, { message: 'Country is required' }),
    timezone: z
      .string()
      .nonempty({ message: 'You must select your preferred timezone' }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords must match',
    path: ['confirmPassword'],
  });

export const menteeSignUpFormDefaultValues = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  confirmPassword: '',
  city: '',
  stateProvince: '',
  country: '',
  timezone: '',
};

export const menteeAlternativeSignUpFormSchema = z.object({
  mentorshipFocus: z
    .array(z.string())
    .nonempty('At least one focus is required'),
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  email: z.string().email('Invalid email'),
  city: z.string().min(2, { message: 'City is required' }),
  stateProvince: z.string().min(2, { message: 'This field is required' }),
  country: z.string().min(3, { message: 'Country is required' }),
  awsCognitoId: z.string().min(1, { message: 'AWS Cognito ID is required' }),
  timezone: z
    .string()
    .nonempty({ message: 'You must select your preferred timezone' }),
});
